<template>
  <div
    class="nav-wrapper md:sticky top-[0px] w-full bg-white relative z-50 roboto h-auto md:h-[150px] shadow-sm flex flex-wrap overflow-hidden"
  >
    <div class="pl-1 md:pl-0 md:ml-4 flex items-center h-full">
      <v-button
        position="left"
        mobile="12"
        tablet="12"
        desktop="12"
        styling="tertiary"
        height="20px"
        textAlign="left"
        :disabled="false"
        style="margin: 0px"
        @onClickEvent="backToOverview"
      >
        <template v-slot:content>
          <span class="flex  back-hover">
            <BackArrow :fill="'#00263E'"/>
          </span>
        </template>
      </v-button>
      <div  class="flex h-full items-center flex-wrap">
        <img class="max-w-[230px] image" :alt="productContent.name" :src="activeOfferImage" />
        <div class="text-wrapper h-fit inline-flex flex-wrap items-center justify-center my-0 mx-auto w-full">
          <p class="text-2xl text-blue-dark mt-0 font-bold">
            {{ globalContent.cartPage.customize }}
          </p>
          <p class="text-2xl text-blue-dark mt-0 font-bold">
            {{ productContent.name }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="ml-auto mr-2 button-wrapper">
      <v-button
        position="center"
        mobile="12"
        tablet="12"
        desktop="12"
        styling="primary rounded"
        :disabled="addToCartDisabled"
        @onClickEvent="addToCart"
      >
        <template v-slot:content>
          {{ submitButtonText }}
        </template>
      </v-button>
    </div> -->
    <!-- <div
      id="mobile-sticky-addtobag"
      v-if="activeProductTab === 'buy' && showSticky"
      class="z-10000 visible-m fixed top-0 left-0 w-full bg-white h-[70px] flex items-center justify-center py-1/2 border-b-1 border-gray-neutral-250"
    >
      <v-button
          position="center"
          mobile="12"
          tablet="12"
          desktop="12"
          styling="primary rounded"
          :disabled="addToCartDisabled"
          @onClickEvent="addToCart"
        >
          <template v-slot:content>
            {{ submitButtonText }}
          </template>
        </v-button>
    </div> -->
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import vButton from "../../../utils/button";
import BackArrow from '../../../utils/icons/back-arrow';
export default {
  components: {
    vButton,
    BackArrow,
  },
  computed: {
    ...mapGetters([
      "activeProductTab",
    ]),
  },
  props: {
    globalContent: {
      type: Object,
      required: true,
    },
    productContent: {
      type: Object,
      required: true,
    },
    activeOfferImage: {
      type: String,
      required: true
    },
    submitButtonText: {
      type: String,
      required: true
    },
    bagStep: {
      type: Number,
      required: true
    },
    addToCartDisabled: {
      type: Boolean,
      required: false
    },
    showSticky: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    ...mapMutations([
      "setActiveProductTabDefault",
    ]),

    addToCart() {
      this.$emit("add-to-cart");
    },

    backToOverview() {
      this.setActiveProductTabDefault();
      window.scrollTo({ top: 0, left: 0 })
    }
  }
};
</script>
<style>
  .image {
    margin: 0 auto;
    max-height: 100%;
  }
  .nav-wrapper {
    padding-top: 0px;
  }
  .button-wrapper {
    display: flex;
  }
  @media (max-width: 730px) {
    .nav-wrapper {
      padding-top: 20px;
    }
    .image {
      margin-top: -40px;
    }
  }

  @media (max-width: 915px) {
    .button-wrapper {
      margin: 0 auto;
    }
  }

  .text-wrapper p {
    width: 100%;
    text-align: center;
  }

  @media (min-width: 745px) {
    .text-wrapper {
      justify-content: flex-start;
      max-width: 300px;
    }
    .text-wrapper p {
      text-align: left;
    }
  }
  .back-hover:active {
    background: #F2F7FF;
  }

  .back-hover:hover p {
    color: #0384FB;
  }

  .back-hover:hover svg path {
    fill: #0384FB;
  } 
</style>
